module.exports = __webpack_public_path__ + "img/ampl.8863e886.svg";